import PropTypes from "prop-types";

export const QrCodePopupPropTypes = {
    popupOpen: PropTypes.bool,
    setOpen: PropTypes.func,
    qrcode: PropTypes.string,
};
